import { CSSProperties } from 'react';
import { Tooltip } from '@mui/material';

const cellOverflowStyle: CSSProperties = {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    width: '100%',
    maxWidth: '100%',
    fontSize: '1.2rem',
};

export const renderOverflowCell = (value: unknown) => {
    const displayValue = value != null && value !== '' && value !== '-' ? String(value) : '-';

    return (
        <Tooltip title={displayValue}>
            <div style={cellOverflowStyle}>
                <p style={{ margin: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {displayValue}
                </p>
            </div>
        </Tooltip>
    );
};

export const renderLinkCell = (href: string, value: unknown) => {
    const displayValue = value != null && value !== '' ? String(value) : '-';

    return (
        <Tooltip title={displayValue}>
            <div style={cellOverflowStyle}>
                <a target="_blank" className="linktxt" href={href} rel="noreferrer" style={cellOverflowStyle}>
                    {displayValue}
                </a>
            </div>
        </Tooltip>
    );
};

export const dataGridSx = {
    width: '100%',
    '& .MuiDataGrid-main': {
        overflowX: 'auto',
    },
    '& .MuiDataGrid-cell': {
        overflow: 'hidden',
    },
    '& .MuiDataGrid-columnHeaderTitle': {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
};
